import { render, staticRenderFns } from "./UpdateModal.vue?vue&type=template&id=3d125024&scoped=true"
import script from "./UpdateModal.vue?vue&type=script&lang=js"
export * from "./UpdateModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateModal.vue?vue&type=style&index=0&id=3d125024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d125024",
  null
  
)

export default component.exports